export default "__VITE_ASSET__20c31dea__"